import e from "./index180.mjs";
const o = e.oneOfType([e.func, e.object]), f = o;
export {
  f as default
};
//# sourceMappingURL=refType.mjs.map
